<template>
  <AdminLayout v-model:activeTab="view">
    <div v-if="view === 'pedidos_almacen'"><CrudPedidos /></div>
    <div v-if="view === 'reporte_produccion'"><ReporteProduccionInyeccion /></div>
  </AdminLayout>
</template>

<script setup>
import { ref } from "vue";
import AdminLayout from "@/components/Layout/AdminLayout.vue";
import CrudPedidos from "@/components/TableroProduccion/SeguimientoPedidos/CrudPedidosSeguimiento.vue";
import ReporteProduccionInyeccion from "@/components/Inyeccion/ReporteProduccion.vue";

const view = ref("pedidos_almacen");
</script>
